const axios = require('axios');

function getPearchPayload() {
  const {
    q, qo, an, crch, rch, utm_source: utmSource,
  } = this.pageParams;
  const pubId = this.getOcodeValue('gslClient');
  const styleId = this.getOcodeValue('component.CSATextAdConfigurationPartial.desktopStyleId');
  return {
    pageContext: {
      anuaaf: 'AdPlat',
      anxu: this.win.location.href,
      anuaqs: this.win.location.search,
      anxd: new Date().toISOString(),
      anuaapp: JSON.stringify({
        queryOrigination: qo || an,
        queryTerm: q || this.doc.title,
        propsId: utmSource,
      }),
      metaInfo: {
        adType: 'csa',
        client: pubId,
        clientChannel: crch || rch,
        styleId,
      },
    },
  };
}

function firePearchAdsensePageView() {
  const pl = this.getPearchPayload();
  const s = this.doc.createElement('script');
  s.src = 'https://adsense.trackinto.com/otrack.js';
  this.doc.head.appendChild(s);
  s.addEventListener('load', () => {
    this.win._otk.push(pl);
  });
}

function firePearchAdsenseConversion() {
  const overridePrefix = this.getOverridePrefix();
  const events = this.getOcodeValue(`${overridePrefix}.pearchAfsFbEvents`).split(',');
  if (typeof this.win.fbq === 'function') {
    events.forEach((e) => {
      const [id, event] = e.split(':');
      this.win.fbq('init', id);
      if (event === 'Purchase') {
        this.win.fbq('trackSingle', id, event, { value: '1', currency: 'USD' });
      } else {
        this.win.fbq('trackSingle', id, event);
      }
    });
  }
  if (this.win.location.pathname !== '/web') {
    const pl = this.win.encodeURIComponent(JSON.stringify(this.getPearchPayload()));
    const { fbclid, gclid } = this.pageParams;
    axios.post(`https://dabu.askmediagroup.com/api/v1/pixel/pearch?fbclid=${fbclid}&gclid=${gclid}&pl=${pl}`,)
  }
}

module.exports = {
  getPearchPayload,
  firePearchAdsensePageView,
  firePearchAdsenseConversion,
};
